import React from "react";

import HomeDeveloper from "../../../../../presentation/pages/developer/home";

import { useAuthGlobal } from "../../../../../contexts/auth-context/auth-context";

const MakeHomeDeveloper: React.FC = () => {
  const { user } = useAuthGlobal();

  const props = {
    user,
  };

  return <HomeDeveloper {...props} />;
};

export default MakeHomeDeveloper;
